import axios, { type AxiosResponse } from 'axios';
import QS from 'qs';

interface DispatchRecord {
  arrival?: string;
  [key: string]: unknown;
}

interface OrderRecord {
  dispatch_id?: number;
  scheduled?: string;
  region?: { id: number };
  [key: string]: unknown;
}

const deserializeDispatch = (dispatch: DispatchRecord) => ({
  ...dispatch,
  arrival: dispatch.arrival ? new Date(dispatch.arrival as string) : dispatch.arrival,
});

const nestedParamsSerializer = (params: Record<string, unknown>) =>
  QS.stringify(params, { arrayFormat: 'brackets', skipNulls: true });

export const createAxiosResources = () => ({
  Region: {
    query: () => ({
      $promise: axios.get('/regions.json').then((response) => response.data),
    }),
  },
  Dispatch: {
    query: (params: Record<string, unknown>) => ({
      $promise: axios
        .get<DispatchRecord[]>('/dispatches.json', { params })
        .then((response) => response.data.map(deserializeDispatch)),
    }),
  },
  Checkin: {
    latest: (params: { dispatch_ids: number[] }) => ({
      $promise: axios
        .get('/checkins/latest.json', {
          params,
          paramsSerializer: nestedParamsSerializer,
        })
        .then((response) => response.data),
    }),
  },
  Order: {
    get: (params: { id: number; account_id: number }) => ({
      $promise: axios
        .get<OrderRecord>(`/accounts/${params.account_id}/orders/${params.id}.json`)
        .then((response) => response.data),
    }),
  },
  User: {},
  Lead: {},
});

export const fetchOrder = (accountId: number, orderId: number): Promise<AxiosResponse<OrderRecord>> =>
  axios.get<OrderRecord>(`/accounts/${accountId}/orders/${orderId}.json`);
